"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGraphQLClient = exports.GraphQLClientProvider = exports.Context = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var uuid_1 = require("uuid");
exports.Context = react_1.default.createContext(null);
exports.GraphQLClientProvider = react_1.default.memo(function (_a) {
    var children = _a.children, bypassToken = _a.bypassToken, defaultEndpoint = _a.defaultEndpoint;
    var client = react_1.default.useMemo(function () {
        return (0, react_common_lib_1.getGraphQLClient)(window.location, {
            defaultEndpoint: defaultEndpoint,
        });
    }, [defaultEndpoint]);
    if (bypassToken) {
        client.setHeader('Authorization', (0, uuid_1.v4)());
    }
    return (0, jsx_runtime_1.jsx)(exports.Context.Provider, __assign({ value: client }, { children: children }));
});
var useGraphQLClient = function () { return (0, react_1.useContext)(exports.Context); };
exports.useGraphQLClient = useGraphQLClient;
